import Route from '@ember/routing/route';

export default class RestrictedRoute extends Route {}
